module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "fm2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Forlorn hope … 1: In early use, a picked body of men, detached to the front to begin the attack.…")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("b. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("transf.")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("fig,")]), _vm._v(" chiefly of persons in a desperate condition.")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("c. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("pl.")]), _vm._v(" The men comprising such a body; hence, reckless bravos.")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("d. A perilous or desperate enterprise.…")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("OXFORD ENGLISH DICTIONARY")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759e2e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm1.vue
// module id = 72
// module chunks = 0